import React from 'react';


function MarkUsagePolicy() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Mark and Badge Usage Policy</h1>

        <div className="space-y-12">
          
          {/* Section 1: Introduction */}
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">1. Introduction</h2>
            <p className="text-gray-800 leading-relaxed mb-4">
              The AASC maintains distinct visual identifiers for "Accountability Declaration" (Tier 1) and "Accountability Declaration" (Accountability Declaration). Strict adherence to this policy is required to maintain the integrity of the ecosystem. Unauthorized or misleading use of these marks constitutes a violation of AASC terms and may result in immediate revocation of status.
            </p>
          </section>

          {/* Section 2: Declaration Badge */}
          <section className="bg-white border border-green-200 p-6 rounded-sm shadow-sm">
            <h2 className="text-xl font-bold text-green-900 mb-4 uppercase tracking-wide border-b border-green-100 pb-2">2. Accountability Declaration Mark</h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-bold text-[#102A43] text-sm uppercase">Who May Use It</h3>
                <p className="text-[#64748B] text-sm">Only entities with currently active "Declared" or "Conditionally declared" status in the Public Registry.</p>
              </div>
              <div>
                <h3 className="font-bold text-[#102A43] text-sm uppercase">Approved Usage</h3>
                <p className="text-[#64748B] text-sm">Website footers, "About Us" pages, proposals, and marketing decks. The mark must always hyperlink to the operator's verification page on the Registry.</p>
              </div>
              <div>
                <h3 className="font-bold text-[#102A43] text-sm uppercase">Permitted Claims</h3>
                <ul className="list-disc pl-5 text-sm text-[#64748B]">
                  <li>"AASC Declared Organization"</li>
                  <li>"Verified Controls for AI Operations"</li>
                  <li>"declared Accountability Structures"</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Section 3: Alignment Badge */}
          <section className="bg-white border border-blue-200 p-6 rounded-sm shadow-sm">
            <h2 className="text-xl font-bold text-[#2F80ED] mb-4 uppercase tracking-wide border-b border-blue-100 pb-2">3. Standards Alignment Badge</h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-bold text-[#102A43] text-sm uppercase">Who May Use It</h3>
                <p className="text-[#64748B] text-sm">Entities with active "Accountability Declared" status. Note: This badge is visually distinct from the Declaration Badge.</p>
              </div>
              <div>
                 <h3 className="font-bold text-[#102A43] text-sm uppercase">Approved Usage</h3>
                 <p className="text-[#64748B] text-sm">Website footers and "About Us" pages only. Not for use on individual product packaging or system interfaces.</p>
              </div>
               <div>
                <h3 className="font-bold text-[#102A43] text-sm uppercase">Permitted Claims</h3>
                <ul className="list-disc pl-5 text-sm text-[#64748B]">
                  <li>"Aligned with AASC Standards"</li>
                  <li>"Signatory to Standards Declaration"</li>
                  <li>"Committed to Responsible AI Operations"</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Section 4: Prohibited Claims */}
          <section className="bg-red-50 p-6 border-l-4 border-red-600">
             <h2 className="text-xl font-bold text-red-900 mb-4 uppercase tracking-wide">4. Strictly Prohibited Claims</h2>
             <p className="text-red-900 text-sm mb-4">The following claims are strictly forbidden for ALL tiers. Making these claims may result in immediate suspension.</p>
             <ul className="grid md:grid-cols-2 gap-4 text-sm font-medium text-red-800">
               <li className="flex items-start gap-2"><span className="text-red-600">✕</span> "AASC Approved AI Agents"</li>
               <li className="flex items-start gap-2"><span className="text-red-600">✕</span> "Guaranteed Safe / Error-Free"</li>
               <li className="flex items-start gap-2"><span className="text-red-600">✕</span> "Regulatory/Government Approval"</li>
               <li className="flex items-start gap-2"><span className="text-red-600">✕</span> "AASC Assumes Liability"</li>
               <li className="flex items-start gap-2"><span className="text-red-600">✕</span> "Risk-Free Implementation"</li>
               <li className="flex items-start gap-2"><span className="text-red-600">✕</span> "GDPR/EU AI Act Compliant" (AASC does not declare legal compliance)</li>
             </ul>
          </section>

        </div>
      </div>
    </>
  );
}

export default MarkUsagePolicy;